
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class EllipShow extends Vue {
  @Prop() input!: string;

  disabled = false;

  mounted() {
    const ellip = (this.$refs.ellip as any).$el as any;
    let width = "";
    let height = "";
    const _this = this as any;
    function isReize() {
      const style = (document.defaultView as any).getComputedStyle(ellip);
      if (width !== style.width || height !== style.height) {
        _this.resize();
      }
      width = style.width;
      height = style.height;
    }
    ellip.__vueSetInterval__ = window.setInterval(isReize, 300);
    this.resize();
  }

  beforeDestroy() {
    const ellip = this.$refs.ellip as any;
    clearInterval(ellip.__vueSetInterval__);
  }

  resize() {
    this.$nextTick(() => {
      if (this.$el.scrollWidth <= this.$el.clientWidth) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    });
  }
}
